"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseFields = void 0;
var util_1 = require("@antv/util");
/** @ignore */
function parseFields(field) {
    if ((0, util_1.isArray)(field)) {
        return field;
    }
    return field.split('*');
}
exports.parseFields = parseFields;
//# sourceMappingURL=parse-fields.js.map